import {MarkedAsReadData, NotificationDataWithUnreadCount} from '../../../../shared/NotificationTypes'
import {UINotificationPanelController} from './UINotificationPanelController'

export class UINotificationActionController {
    private readonly notificationPanel: UINotificationPanelController

    constructor(notificationPanel: UINotificationPanelController) {
        this.notificationPanel = notificationPanel
    }

    addNotificationsToPanel(notificationDataWithUnreadCount: NotificationDataWithUnreadCount) {
        this.notificationPanel.addNotifications(notificationDataWithUnreadCount.notifications)
        this.notificationPanel.displayNumberOfUnreadNotifications(notificationDataWithUnreadCount.unreadNotificationCount)
    }

    markNotificationAsRead(markedAsReadData: MarkedAsReadData) {
        this.notificationPanel.displayNumberOfUnreadNotifications(markedAsReadData.unreadNotificationCount)
        if(markedAsReadData.markAllAsRead) return this.notificationPanel.markAllNotificationsAsRead()
        if(markedAsReadData.notificationMarkedAsRead) return this.notificationPanel.markNotificationAsRead(markedAsReadData.notificationMarkedAsRead.id)
    }
}
